const Swal = require('sweetalert2');
const Translator = require('./vendor/translator.js');

const Dialog = Swal.mixin({
	customClass: {
		confirmButton: 'btn btn-blue',
		cancelButton: 'btn btn-secondary',
	},
	buttonsStyling: false,
	showCloseButton: true
});

const SuccessDialog = Dialog.mixin({
	type: 'success',
});

const ErrorDialog = Dialog.mixin({
	type: 'error',
});

const ConfirmationDialog = Dialog.mixin({
	confirmButtonText: Translator.translate('dialog.ConfirmationDialog.confirmButtonText'),
	cancelButtonText: Translator.translate('dialog.ConfirmationDialog.cancelButtonText'),
	showCancelButton: true,
	type: 'question',
});

const DangerConfirmationDialog = ConfirmationDialog.mixin({
	customClass: {
		confirmButton: 'btn btn-pink',
		cancelButton: 'btn btn-secondary',
	},
	focusConfirm: false,
	focusCancel: true,
	type: 'warning',
});

const DeletionDialog = DangerConfirmationDialog.mixin({
	confirmButtonText: Translator.translate('dialog.DeletionDialog.confirmButtonText'),
});

module.exports = {
	CleanDialog: Swal,
	Dialog: Dialog,
	SuccessDialog: SuccessDialog,
	ErrorDialog: ErrorDialog,
	ConfirmationDialog: ConfirmationDialog,
	DangerConfirmationDialog: DangerConfirmationDialog,
	DeletionDialog: DeletionDialog,
};
